/**
 * ProtectedRoute - redirects to login if not authenticated
 */

import { Navigate } from 'react-router-dom';
import { useUserContext } from '@/contexts/UserContext';
import { useSafeLocation } from '@/hooks/useSafeLocation';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading, authReady } = useUserContext();
  const location = useSafeLocation();

  // Show loading while checking auth state
  // authReady is false until initial session check completes
  if (isLoading || !authReady) {
    return (
      <div className="min-h-screen bg-bg-primary flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/auth/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}

export default ProtectedRoute;
